
import PagePagination from '~/components/page/PagePagination.vue';
import ProductCard from '~/components/product/ProductCard.vue';
import ProductCardLoad from '~/components/product/ProductCardLoad.vue';
import SPage from '~/components/page/SPage.vue';

import { formatFilterMeta } from '~/helpers/meta';
import Filters from '~/components/category/filters/Filters.vue';
import CategoryLoaders from '~/components/category/CategoryLoaders';
import { ymGoalCheck } from '~/helpers/ym_helper';
import { AppMixin, CategoryMixin } from '~/node_modules/sitis-nuxt/lib/mixins';

export default {
  name: 'Catalog',

  data() {
    return {
      seoCategory: {},

      isScrolling: false,

      currentPageCounter: 24,
      optionPageCounter: [24, 48, 72],
      currentFilter: { id: 'default', value: 'По умолчанию' },

      isVisibleFullCategories: false,
      host: '',
    };
  },

  components: {
    CategoryLoaders,
    PagePagination,
    SPage,
    ProductCard,
    ProductCardLoad,
    Filters,
  },

  mixins: [AppMixin, CategoryMixin],

  computed: {
    getFullPath() {
      if (process.client) {
        const host = window.location.origin;
        return `${host}${this.$route.fullPath}`;
      }
    },

    isShowAllSeoText() {
      return Boolean(
        this.pagination.page === 1
        && !Object.keys(this.selectedFilters).length,
      );
    },

    isShowDescription() {
      return this.category?.dynamicFields?.show_description === true ;
    },

    isLoading() {
      return Boolean(
        this.loadersMap.catalog
        || this.loadersMap.category
        || this.loadersMap.filters,
      );
    },

    selected() {
      const filtersInit = [...this.filters];
      const selectedFilters = { ...this.selectedFilters };
      const filters = [];

      Object.keys(selectedFilters).forEach((filterKey) => {
        const filterItem = filtersInit.find((t) => t.slug === filterKey);
        const selected = selectedFilters[filterKey];

        if (filterItem) {
          Object.keys(selected).forEach((variantKey) => {
            const variant = filterItem.variants.find(
              (t) => String(t.slug) === String(variantKey),
            );

            if (variant && filterKey !== 'pol') {
              filters.push({
                slug: filterKey,
                variant,
              });
            }
          });
        }
      });
      return filters;
    },

    // Загружаются ли товары
    isProductLoad() {
      return Boolean(
        this.loadersMap.filters
        || this.loadersMap.products
        || this.loadersMap.updateFilters,
      );
    },

    cmsDescriptionText() {
      const isAdv = this.$store.state.currentPhone.isAdvContent;
      const descriptions = this.seoCategory?.description || '';

      if (isAdv) {
        const adsPhone = this.vars?.['Телефон для переходов с рекламы'];

        return descriptions.replace('8 (800) 200-48-97', adsPhone);
      }

      return descriptions;
    },

    // cmsBottomLandingPage() {
    //   return this.filterPages?.[0]?.bottomText;
    // },

    cmsTopLandingPage() {
      return this.filterPages?.[0]?.text;
    },

    extensions() {
      return ['promotions', 'customDataFields', 'short_characteristics', 'characteristics'];
    },

    titleH1() {
      if (this.filterPages.length) {
        return this.filterPages?.[0]?.title;
      }
      return this?.seoCategory?.title || this?.category?.name || '';
    },

    titleMetaCaregory() {
      const activeFilter = { ...this.selectedFilters };
      const category = this.category?.slug;
      const string = formatFilterMeta(
        activeFilter,
        category,
        this.appCfg,
        this.filters,
      );

      const pagePostfix = this.pagination.page > 1 ? ` страница - ${this.pagination.page}` : '';

      if (!string || this.filterPages?.[0]) {
        if (this.filterPages?.[0]?.seo?.title) {
          return this.filterPages?.[0]?.seo?.title + pagePostfix;
        } if (this.seoCategory?.seo_title) {
          return this.seoCategory?.seo_title + pagePostfix;
        }
        return '';
      }

      if (this.filterInfo?.seo_title) {
        return this.filterInfo?.seo_title + pagePostfix;
      }

      const messageFirstPart = `Купить ${this.category?.name}`;
      return `${messageFirstPart} ${string}`;
    },

    descriptionMetaCategory() {
      const activeFilter = { ...this.selectedFilters };
      const category = this.category?.slug;

      if (this.filterPages?.[0]) {
        return (
          this.filterPages?.[0]?.seo?.description
          || this?.category?.seo?.description
          || this.seoCategory?.seo_description
          || ''
        );
      }

      const pagePostfix = this.pagination.page > 1 ? ` страница - ${this.pagination.page}` : '';

      if (this.filterInfo?.seo_description) {
        return this.filterInfo?.seo_description + pagePostfix;
      } if (this.category?.seo?.description) {
        return this.category?.seo?.description + pagePostfix;
      }
      return `Покупайте ${this.category?.name}${pagePostfix}`;
    },

    isShowCmsContent() {
      return Boolean(
        !this.cmsDescriptionText,
        // this.selected.length,
        // && !this.isHasSubdomain
        // && !this.cmsBottomLandingPage,
      );
    },

    sortOptions() {
      return [
        {
          id: 'default',
          type: 'string',
          value: 'По умолчанию',
        },
        {
          id: 'price',
          type: 'string',
          value: 'Стоимость (дешевле)',
        },
        {
          id: '-price',
          type: 'string',
          value: 'Стоимость (дороже)',
        },
        {
          id: 'rating',
          type: 'string',
          value: 'По пулярность',
        },
        {
          id: 'quantity',
          type: 'string',
          value: 'Наличие',
        },
      ];
    },

    childrenCategories() {
      const currenctCategoryId = this.category?.id;
      let categoriesList = this.categoryChildrens || [];
      if ((this.categoryChildrens || []).find((t) => t.id === currenctCategoryId)) {
        categoriesList = (this.categoryChildrens || []).find((t) => t.id === currenctCategoryId)?.items;
      }

      if (!this.isVisibleFullCategories) {
        return [...categoriesList].splice(0, 3);
      }

      return categoriesList;
    },
    totalCountChildrenCategories() {
      const currenctCategoryId = this.category?.id;
      let categoriesList = this.categoryChildrens || [];
      if ((this.categoryChildrens || []).find((t) => t.id === currenctCategoryId)) {
        categoriesList = (this.categoryChildrens || []).find((t) => t.id === currenctCategoryId)?.items;
      }
      return categoriesList.length;
    },

    countFinedeProducts() {
      if (this.isLoading) {
        return '...';
      }
      return this.$numberFormat(this.total);
    },

    canonicalLink: function () {
      const fullPath = String(String(this.$route?.fullPath || '').split("?")?.[0] || "").split("#")?.[0];
      return `https://${ this.host }${fullPath || ""}`;
    },
  },

  watch: {
    loadersMap: {
      deep: true,
      handler() {
        (async () => {
          await this.scrollToProduct();
        })();
      },
    },
    'loadersMap.filters': {
      deep: true,
      handler(newVal, oldVal) {
        this.onScrollPageToPosition();
      },
    },
  },

  methods: {
    onChangePagesCounter(event) {
      this.onChangePerPage(event);
    },

    onChangeCurrentSort({ id }) {
      this.onChangeSort(id);
    },

    onScrollPageToPosition() {
      if (this.selected.length && this.routerParams.page < 2) {
        const offsetTop = window.innerWidth < 900 ? 170 : 120;
        const scrollTop = document.getElementById('search-scroll')?.offsetTop || 0;

        window.scrollTo({
          top: scrollTop - offsetTop - 40,
          behavior: 'smooth',
        });
      }
    },

    async scrollToProduct() {
      if (this.loadersMap.filters || this.loadersMap.products) {
        return null;
      }

      // Если серверный рединг, отменяем функцию
      if (this.$isServer) {
        return null;
      }

      setTimeout(() => {
      }, 500);

      const loadPrevProducts = this.$cookies.get('load-prev-products');
      if (loadPrevProducts) {
        return null;
      }

      // Ищем, есть ли ID скролируемого продукта
      const scrollToProductId = this.$cookies.get('scroll-to-product-id');
      if (!scrollToProductId) {
        return null;
      }

      // Ищем, нашелся ли такой элемент по ID
      const element = document.getElementById(`product-${scrollToProductId}`);
      if (!element) {
        return null;
      }

      // Удаляем элемент
      this.$cookies.remove('scroll-to-product-id');

      // Вычесляем позицю и делаем скрол к элементу
      const container = document.body;
      const { offsetTop } = element;
      const offsetHeader = window.innerWidth < 1000 ? 80 : 160; // 80 - отсуп мобильный; 160 - отступ ПК
      window.scrollTo({
        top: offsetTop - offsetHeader,
      });
    },

    onPageChange(page) {
      const offsetTop = window.innerWidth < 900 ? 170 : 80;
      const scrollTop = document.getElementById('search-scroll')?.offsetTop || 0;

      window.scrollTo({
        top: scrollTop - 200,
        behavior: 'smooth',
      });

      this.onChangePage(page);
    },

    // Запросить прайс лист
    requestPriceList() {
      this.$store.commit('pop-up-back-call/openCallPricePopup', {
        yandexMetriks: {
          ymGoal: 'zapros_prajs_list_sent',
          ymNumber: process.env.yandexMetriks,
        },
      });

      ymGoalCheck({
        ymGoal: 'zapros_prajs_list_form',
        ymNumber: process.env.yandexMetriks,
      });
    },

    openFullChildrenCategories() {
      this.isVisibleFullCategories = !this.isVisibleFullCategories;
    },
  },

  asyncData(ctx) {
    const host = ctx?.req?.headers?.host || window?.location.host || '';
    const catalog = ctx.store.getters['catalog/categories'];

    if (!catalog.length) {
      ctx.store.dispatch('catalog/getCatalog');
    }

    const isHasSubdomain = Boolean(host.split('.').length === 3);
    return {
      isHasSubdomain,
      host,
    };
  },

  async fetch() {
    await this.loadCategoryDetailed();
    await this.loadCategory(false);
    await this.loadFilter();

    const { $api } = this;
    const { params } = this.$route;
    const routeName = this.$route.name;
    const store = this.$store;
    const { error } = this.$nuxt;

    if (routeName !== 'catalog-all') {
      return {};
    }

    // Инициализация SLUG страницы
    const pathMatch = ((params?.pathMatch || '').split('/f/')?.[0] || '')
      .split('/')
      .pop();

    // Полный путь (без фильтров)
    const fullPathMatch = (params?.pathMatch || '').split('/f/')?.[0] || '';

    // Инициализация всех категорий
    const categories = store?.state?.catalog?.categories || [];

    // Поиск нужной категории ID
    const categoriesId = categories.find((cat) => cat.url == `/catalog/${fullPathMatch}`)?.id
      || null;

    if (!categoriesId) {
      error({
        statusCode: 404,
        message: 'Категория не найдена',
      });
      return null;
    }

    // Получение SEO категории
    const seoCategory = await $api.agent.transport
      .get(`categories/${pathMatch}`)
      .then((res) => res.data)
      .catch(() => ({}));

    this.seoCategory = seoCategory;
  },

  head() {
    const data = {
      title: this.titleMetaCaregory,
      meta: [
        {
          hid: 'metadescription',
          name: 'description',
          content: this.descriptionMetaCategory,
        },
        { name: 'keywords', content: String(this.filterInfo?.seo_keywords || this.seoCategory?.seo_keywords) },
        {
          hid: 'og:title',
          name: 'title',
          property: 'og:title',
          content: this.seoCategory?.meta_title || this.seoCategory?.seo_title || '',
        },
        {
          hid: 'og:description',
          name: 'title',
          property: 'og:description',
          content: this.seoCategory?.meta_description || this.seoCategory?.seo_description || '',
        },
      ],
      link: [],
    };

    if (this.canonicalLink) {
      data.link.push({ rel: 'canonical', href: this.canonicalLink });
    }
    // if (this.$route.fullPath !== this.$route.path) {
    //   data.link.push({ rel: 'canonical', href: `https://${this.host}${this.$route.path}` });
    // }

    return data;
  },
};
